import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Drawer } from 'antd';
// import "../Sidebar.css"; // Import shared CSS

// Import icons
import packages from '../../../../Assets/Icons/packages.svg';
import users from '../../../../Assets/Icons/users.svg';
import admins from '../../../../Assets/Icons/admins.svg';
import category from '../../../../Assets/Icons/category.svg';
import azkar from '../../../../Assets/Icons/azkhar.png';
import hamburgerIcon from '../../../../Assets/Icons/hamburger-icon.svg';

function MobileSideBar({ parent }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    return () => {
      setVisible(false);
    };
  }, []);

  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  return (
    <div>
      <img
        src={hamburgerIcon}
        alt="hamburgerIcon"
        onClick={showDrawer}
        className="m-4 cursor-pointer hamburgerIcon"
      />
      <Drawer
        title="مقرأة"
        placement="left"
        onClose={onClose}
        open={visible}
        className="sideBar"
        mask={true}
      >
        <Link to="/users" className={`${parent === 'users' && 'activeTab'} d-flex tab`}>
          <img src={users} alt="users" />
          <label>الطلاب</label>
        </Link>

        <Link to="/admins" className={`${parent === 'admins' && 'activeTab'} d-flex tab`}>
          <img src={admins} alt="admins" />
          <label>المديرون</label>
        </Link>

        <Link
          to="/sheikhs"
          className={`${parent === 'sheikhs' && 'activeTab'} d-flex tab`}
        >
          <img src={packages} alt="sheikhs" />
          <label>المعلمون</label>
        </Link>

        <Link
          to="/endedlectures"
          className={`${parent === 'endedlectures' && 'activeTab'} d-flex tab`}
        >
          <img src={packages} alt="endedlectures" />
          <label>المحاضرات</label>
        </Link>

        <Link
          to="/lectureWithAttenders"
          className={`${parent === 'lectureWithAttenders' && 'activeTab'} d-flex tab`}
        >
          <img src={packages} alt="lectureWithAttenders" />
          <label>الحضور</label>
        </Link>

        <Link to="/groups" className={`${parent === 'groups' && 'activeTab'} d-flex tab`}>
          <img src={packages} alt="groups" />
          <label>المجموعات</label>
        </Link>

        <Link
          to="/number-of-attendence"
          className={`${parent === 'numberOfAttendence' && 'activeTab'} d-flex tab`}
        >
          <img src={packages} alt="numberOfAttendence" />
          <label>الطلاب الحضور</label>
        </Link>

        {/* <Link
          to="/adhkar-categories"
          className={`${
            parent === "adhkar-categories" && "activeTab"
          } d-flex tab`}
        >
          <img src={packages} alt="adhkar-categories" />
          <label>تصنيفات الأذكار</label>
        </Link> */}

        <Link to="/adhkar" className={`${parent === 'adhkar' && 'activeTab'} d-flex tab`}>
          <img src={packages} alt="adhkar" />
          <label>أذكار</label>
        </Link>

        <Link to="/parts" className={`${parent === 'parts' && 'activeTab'} d-flex tab`}>
          <img src={packages} alt="parts" />
          <label>الأجزاء</label>
        </Link>
      </Drawer>
    </div>
  );
}

export default MobileSideBar;
